import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NavigationService } from '../../services/navigation/navigation.service';
import { CacheService } from '../../services/cache/cache.service';
import { CommonService } from '../../services/common/common.service';
import { Column } from '../interfaces/column.interface';
import moment from 'moment';
import { UsersDataService } from './users-data.service';
import { User, UsersResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class PushDevicesColumnsService {

  public users: User[] = [];
  public developmentsOptions = [{
    value: 'Production',
    label: 'DEVELOPMENTSPRODUCTION',
    css: 'primary'
  }, {
    value: 'Sandbox',
    label: 'DEVELOPMENTSSANDBOX',
    css: 'success'
  }];
  public statusesOptions = [{
    value: 'Active',
    label: 'STATUSESACTIVE',
    css: 'primary'
  }, {
    value: 'Uninstalled',
    label: 'STATUSESUNINSTALLED',
    css: 'success'
  }];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};

  constructor(
    private translate: TranslateService,
    private navigation: NavigationService,
    private cache: CacheService,
    private common: CommonService,
    private usersDataService: UsersDataService,

  ) {
    this.getUsers()
  }

  getUsers(offset: number = 0): void {
    const cacheKey: string = 'users.cache'
    const cache: any = this.cache.get(cacheKey);
    if (cache !== null && offset === 0) {
      this.users = cache.results
      return;
    }
    const parameters = Object.assign(this.defaultParameters, {offset: offset + ''});
    this.usersDataService.getUsers(parameters).subscribe((response: UsersResult|any) => {
      if (response !== null) {
        if (offset === 0) {
          this.users = response.results;
        } else {
          this.users = this.users.concat(response.results);
        }
        if (response.inlineCount > this.users.length) {
          offset = offset + parseInt(this.defaultParameters.limit + '', 10);
          this.getUsers(offset);
        }
        response.results = this.users;
        this.cache.set(cacheKey, response);
      }
    });
  }

  getColumns(): Column[] {
    return [
      { field: 'id', sortField: 'id', title: this.translate.instant('ID'), show: (this.navigation.getParamValue('pushDevices.id.showFiled', true) && true), displayInList: true, type: 'numericValue'},
      { field: 'appName', sortField: 'appName', title: this.translate.instant('APPNAME'), show: (this.navigation.getParamValue('pushDevices.appName.showFiled', true) && true), displayInList: true, type: 'textValue'},
      { field: 'appVersion', sortField: 'appVersion', title: this.translate.instant('APPVERSION'), show: (this.navigation.getParamValue('pushDevices.appVersion.showFiled', true) && true), displayInList: true, type: 'textValue'},
      { field: 'deviceUid', sortField: 'deviceUid', title: this.translate.instant('DEVICEUID'), show: (this.navigation.getParamValue('pushDevices.deviceUid.showFiled', true) && true), displayInList: true, type: 'textValue'},
      { field: 'deviceReg', sortField: 'deviceReg', title: this.translate.instant('DEVICEREG'), show: (this.navigation.getParamValue('pushDevices.deviceReg.showFiled', true) && true), displayInList: true, type: 'textValue'},
      { field: 'deviceToken', sortField: 'deviceToken', title: this.translate.instant('DEVICETOKEN'), show: (this.navigation.getParamValue('pushDevices.deviceToken.showFiled', true) && true), displayInList: true, type: 'textValue'},
      { field: 'deviceName', sortField: 'deviceName', title: this.translate.instant('DEVICENAME'), show: (this.navigation.getParamValue('pushDevices.deviceName.showFiled', true) && true), displayInList: true, type: 'textValue'},
      { field: 'deviceEmail', sortField: 'deviceEmail', title: this.translate.instant('DEVICEEMAIL'), show: (this.navigation.getParamValue('pushDevices.deviceEmail.showFiled', false) && true), displayInList: true, type: 'textValue'},
      { field: 'deviceModel', sortField: 'deviceModel', title: this.translate.instant('DEVICEMODEL'), show: (this.navigation.getParamValue('pushDevices.deviceModel.showFiled', false) && true), displayInList: true, type: 'textValue'},
      { field: 'deviceVersion', sortField: 'deviceVersion', title: this.translate.instant('DEVICEVERSION'), show: (this.navigation.getParamValue('pushDevices.deviceVersion.showFiled', false) && true), displayInList: true, type: 'textValue'},
      { field: 'isEnabledBadge', sortField: 'isEnabledBadge', title: this.translate.instant('ISENABLEDBADGE'), show: (this.navigation.getParamValue('pushDevices.isEnabledBadge.showFiled', false) && true), displayInList: true, type: 'booleanValue', filterData: this.navigation.booleanOptions },
      { field: 'isEnabledAlert', sortField: 'isEnabledAlert', title: this.translate.instant('ISENABLEDALERT'), show: (this.navigation.getParamValue('pushDevices.isEnabledAlert.showFiled', false) && true), displayInList: true, type: 'booleanValue', filterData: this.navigation.booleanOptions },
      { field: 'isEnabledSound', sortField: 'isEnabledSound', title: this.translate.instant('ISENABLEDSOUND'), show: (this.navigation.getParamValue('pushDevices.isEnabledSound.showFiled', false) && true), displayInList: true, type: 'booleanValue', filterData: this.navigation.booleanOptions },
      { field: 'development', sortField: 'development', title: this.translate.instant('DEVELOPMENT'), show: (this.navigation.getParamValue('pushDevices.development.showFiled', false) && true), displayInList: true, type: 'enumValue', filterData: this.developmentsOptions},
      { field: 'status', sortField: 'status', title: this.translate.instant('STATUS'), show: (this.navigation.getParamValue('pushDevices.status.showFiled', false) && true), displayInList: true, type: 'enumValue', filterData: this.statusesOptions},
      { field: 'ip', sortField: 'ip', title: this.translate.instant('IP'), show: (this.navigation.getParamValue('pushDevices.ip.showFiled', false) && true), displayInList: true, type: 'textValue'},
      { field: 'createdAt', sortField: 'createdAt', title: this.translate.instant('CREATEDAT'), show: (this.navigation.getParamValue('pushDevices.createdAt.showFiled', false) && true), displayInList: true, type: 'dateValue', valueFormatter: this.translate.instant('DATETIMEFORMAT')},
      { field: 'creatorUser', title: this.translate.instant('CREATORUSER'), type: 'linkValue', filterData: this.users, show: (this.navigation.getParamValue('pushDevices.creatorUser.showFiled', false) && true), displayInList: true, filterField: 'creatorUser.id', displayField: 'username', sortField: 'creatorUser.username', url: 'users' },
      { field: 'modifiedAt', sortField: 'modifiedAt', title: this.translate.instant('MODIFIEDAT'), show: (this.navigation.getParamValue('pushDevices.modifiedAt.showFiled', false) && true), displayInList: true, type: 'dateValue', valueFormatter: this.translate.instant('DATETIMEFORMAT')},
      { field: 'modifierUser', title: this.translate.instant('MODIFIERUSER'), type: 'linkValue', filterData: this.users, show: (this.navigation.getParamValue('pushDevices.modifierUser.showFiled', false) && true), displayInList: true, filterField: 'modifierUser.id', displayField: 'username', sortField: 'modifierUser.username', url: 'users' },
      { field: 'actions', title: this.translate.instant('ACTIONS'), type: 'static', show: true, displayInList: true, sortField: null},
    ];
  }

  format(fieldName: string, value: any) {
    if (fieldName.toLowerCase().indexOf('time') > -1) {
      return moment(value).format('YYYY-MM-DD HH:mm');
    } else if (fieldName.toLowerCase().indexOf('date') > -1) {
      return moment(value).format('YYYY-MM-DD');
    }
    return value;
  }

}
